import { render, staticRenderFns } from "./CompanyUserPicker.vue?vue&type=template&id=08dd60a6"
import script from "./CompanyUserPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyUserPicker.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports